import type { ButtonProps } from '@mui/material';
import { Button } from '../../../Button/Button';
import { ADD_BUTTON_CLASSNAME } from '../../model/constants';

interface Props {
  variant?: ButtonProps['variant'];
  title: string;
  onClick: () => void;
}

export function AddButton({ title, variant, onClick }: Props) {
  return (
    <Button
      className={ADD_BUTTON_CLASSNAME}
      variant={variant || 'contained'}
      sx={{
        px: 1.5,
        py: 0.625,
        borderRadius: 2,
        lineHeight: '1.125rem',
      }}
      onClick={onClick}
    >
      {title}
    </Button>
  );
}
